import React from 'react';
//import '../common/css/footer.css';

function footer(props) {
    const MoveToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className='footer'>
            <footer className='footer'>
                <div className='footer__inner'>
                    <div className='footer__corp'>
                        <p className='corp__desc'>서울시 서소문로 11길 50 신아빌딩 1층</p>
                        <p className='corp__desc'>락소홀딩스 대표이사 정옥,정진우</p>
                        <p className='corp__desc'>사업자등록번호 110 - 81 - 40725</p>
                        <p className='corp__desc'>통신판매업신고 중구 03244호</p>
                        <p className='corp__desc'>
                            대표번호 <span className='m-bold'>1544 - 1717</span>
                        </p>
                    </div>
                    <p className='copyright'>Copyright © Philippine Airline, All Rights Reserved.</p>
                </div>

                <div className='totop_button_wrap'>
                    <button className='totop_btn' onClick={MoveToTop}></button>
                </div>
            </footer>
        </div>
    );
}

export default footer;
